import script from "./Register.vue?vue&type=script&setup=true&lang=js"
export * from "./Register.vue?vue&type=script&setup=true&lang=js"

import "./Register.vue?vue&type=style&index=0&id=06822d02&lang=less&scoped=true"
import "./Register.vue?vue&type=style&index=1&id=06822d02&lang=less"

import exportComponent from "/data/web/pay/thpay/thpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06822d02"]])

export default __exports__